export default __webpack_public_path__ + "static/media/vault.589c7e17.png";